import { useQuery } from '@tanstack/react-query';
import { RemitSettingStatus } from '../models/remit-setting-status.ts';
import { fetchRemitSettingStatuses } from '../api/remit-settings.ts';

export default function useRemitSettingStatus() {
  const queryFn = fetchRemitSettingStatuses;
  return useQuery<RemitSettingStatus[]>({
    queryKey: ['remitSettingStatuses'],
    queryFn,
  });
}
